module.exports = __webpack_public_path__ + "static/media/IMG_3559.67bb9499.jpg";